import React, { useState, useEffect, memo } from "react";
import useStyles from "./styles";
import clsx from "clsx";
import DialogBottom from "components/DialogBottom";
import GroupedButtons from "components/GroupedButtons";

import { Grid, Button } from "@material-ui/core";
import { Images } from "config/images";
import { formatCash } from "config/constant";

const CardGiftItem = memo(props => {
	const classes = useStyles();
	const {
		isVoucher,
		shopId,
		loyaltyId,
		gift,
		handleConfirmChangeGift,
		pointShop
	} = props;

	const { level, giftProductGroupName, quantity, point, products } = gift;

	const [listProducts, setListProducts] = useState([]);
	const [openDialog, setOpenDialog] = useState(false);
	const [totalQuantity, setTotalQuantity] = useState(0);

	useEffect(() => {
		if (products.length > 0) {
			setListProducts(products);
		}
	}, [products]);

	const handleChangeGift = () => {
		if (!isVoucher) {
			setOpenDialog(true);
		}
	};

	const handleCountProduct = (id, count) => {
		const newListProduct = listProducts.map(item => {
			if (item.productId === id) {
				return { ...item, quantity: count };
			} else {
				if (item.quantity) {
					return item;
				} else {
					return { ...item, quantity: 0 };
				}
			}
		});
		setListProducts(newListProduct);
	};

	useEffect(() => {
		if (listProducts.length > 0) {
			const newList = listProducts.map(item => item?.quantity);
			const sum = newList.reduce(
				(previousValue, currentValue) => previousValue + currentValue
			);
			setTotalQuantity(sum);
		}
	}, [listProducts]);

	const handleCancel = () => {
		setOpenDialog(false);
		setTotalQuantity(0);
	};

	const handleConfirm = () => {
		if (totalQuantity <= quantity) {
			const formatArray = listProducts.map(item => ({
				productId: item.productId,
				quantity: item.quantity
			}));
			const formatData = {
				shopId: shopId,
				loyaltyId: loyaltyId,
				level: level,
				items: formatArray
			};
			handleConfirmChangeGift(formatData);
			handleCancel();
		}
	};

	return (
		<React.Fragment>
			<Grid classes={{ root: classes.root }}>
				<img
					src={isVoucher ? Images.bgVoucher : Images.bgGift}
					alt={isVoucher ? "bgVoucher" : "bgGift"}
					className={classes.rootLogo}
				/>
				<Grid classes={{ root: classes.bodyText }}>
					<Grid classes={{ root: classes.productName }}>
						{giftProductGroupName}
					</Grid>
					<Grid classes={{ root: classes.pointProduct }}>
						<Grid classes={{ root: classes.point }}>
							{formatCash(point)} điểm
						</Grid>
						<Grid classes={{ root: classes.title }}>
							Số lượng: {quantity} lẻ
						</Grid>
					</Grid>
					<Button
						classes={{
							root: classes.btnDefault,
							disabled: classes.disabledConfirm
						}}
						disabled={point > pointShop || isVoucher}
						onClick={() => handleChangeGift()}
					>
						{isVoucher ? "Dùng ngay" : "Đổi quà"}
					</Button>
				</Grid>
			</Grid>
			<DialogBottom open={openDialog} handleClose={handleCancel}>
				<Grid style={{ position: "relative" }}>
					<Grid
						classes={{ root: classes.dialogHeader }}
						style={{ textAlign: "center" }}
					>
						<Grid classes={{ root: classes.titleHeader }}>
							Đổi quà
						</Grid>
						<Grid classes={{ root: classes.titleProgram }}>
							{giftProductGroupName}
						</Grid>
					</Grid>
					<Grid classes={{ root: classes.dialogHeader }}>
						<Grid classes={{ root: classes.textListProduct }}>
							Danh sách sản phẩm
						</Grid>
						<Grid classes={{ root: classes.subTextListProduct }}>
							Vui lòng chọn <span>{quantity} sản phẩm</span> trong
							giỏ quà
						</Grid>
					</Grid>
					<Grid classes={{ root: classes.listProducts }}>
						<Grid classes={{ root: classes.products }}>
							{listProducts.map(product => (
								<Grid
									classes={{ root: classes.wrapperProduct }}
									key={product?.productId}
								>
									<Grid
										classes={{ root: classes.imageProduct }}
									>
										<img
											src={product.productImage}
											alt={`productImage_${product?.id}`}
										/>
									</Grid>
									<Grid
										classes={{ root: classes.infoProduct }}
									>
										<Grid
											classes={{
												root: classes.productName
											}}
										>
											{product.productName}
										</Grid>
										<Grid
											classes={{
												root: classes.quantityGift
											}}
										>
											<Grid
												classes={{
													root: classes.quantity
												}}
											>
												Số lượng
											</Grid>
											<GroupedButtons
												productId={product.productId}
												handleCountProduct={
													handleCountProduct
												}
											/>
										</Grid>
									</Grid>
								</Grid>
							))}
						</Grid>
					</Grid>
					<Grid classes={{ root: classes.wrapperFooter }}>
						<Grid classes={{ root: classes.productsFooter }}>
							<Grid classes={{ root: classes.wrapperTitle }}>
								<Grid classes={{ root: classes.titleFooter }}>
									Tổng điểm quy đổi
								</Grid>
								<Grid
									classes={{ root: classes.titleFooter }}
									style={{ fontWeight: 500 }}
								>
									{formatCash(point)} điểm
								</Grid>
							</Grid>
							<Grid classes={{ root: classes.wrapperTitle }}>
								<Grid classes={{ root: classes.titleFooter }}>
									Tổng số lượng
								</Grid>
								<Grid
									classes={{ root: classes.titleFooter }}
									style={{ fontWeight: 500 }}
								>
									x {totalQuantity}
								</Grid>
							</Grid>
						</Grid>
						<Grid classes={{ root: classes.wrapperError }}>
							{totalQuantity > quantity && (
								<Grid classes={{ root: classes.textError }}>
									Vượt quá số lượng cho phép. Vui lòng chọn
									lại
								</Grid>
							)}
						</Grid>
						<Grid
							container
							spacing={1}
							classes={{ root: classes.mt10 }}
						>
							<Grid item xs={6}>
								<Grid
									classes={{ root: classes.btnCancel }}
									onClick={() => handleCancel()}
								>
									Đóng
								</Grid>
							</Grid>
							<Grid item xs={6}>
								<Grid
									component="button"
									disabled={
										totalQuantity > quantity ||
										totalQuantity === 0
									}
									classes={{
										root: clsx(
											classes.btnConfirm,
											totalQuantity > quantity ||
												totalQuantity === 0
												? classes.btnConfirmDisabled
												: ""
										)
									}}
									onClick={() => handleConfirm()}
								>
									Xác nhận
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</DialogBottom>
		</React.Fragment>
	);
});

export default CardGiftItem;
